export const SUPPLIER_KEY = "SUPPLIER";

export const SUPPLIER_CACHE_KEY = {
  LIST: [SUPPLIER_KEY, "LIST"] as const,
  CLOSURES: (supplierId: string) =>
    [SUPPLIER_KEY, "CLOSURES", supplierId] as const,
};
